// Webpack Imports

(function () {
    'use strict';

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function (e) {
            var search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });
})();



// Use jQuery in place of $
(function ($) {
    $(document).ready(function () {
        // ============================================
        // Site Header Stuff
        // ============================================
        $('header .hamburger').click(function () {
            if ($('body').hasClass('navbar-shown') == true) {
                $('body').removeClass('navbar-shown')
            } else {
                $('body').addClass('navbar-shown')
            }

            if ($('header .hamburger').hasClass('is-active')) {
                $('header .hamburger').removeClass('is-active');
            } else {
                $('header .hamburger').addClass('is-active')
            }
        });


        $('.members.hamburger').click(function () {
            if ($('body').hasClass('sidebar-shown') == true) {
                $('body').removeClass('sidebar-shown')
            } else {
                $('body').addClass('sidebar-shown')
            }

            if ($('.members.hamburger').hasClass('is-active')) {
                $('.members.hamburger').removeClass('is-active');
            } else {
                $('.members.hamburger').addClass('is-active')
            }
        });


        // ============================================
        // Members Page Stuff
        // ============================================
        $('.members-sidebar').on('click', '.dropdown-toggle', function () {

            $('.members-sidebar li ul').removeClass('show');

            console.log('click');
            $(this).next('ul').addClass('show');
        });

        // ============================================
        // Form Validation Stuff
        // ============================================
        window.verifyRecaptchaCallback = function (response) {
            $('input[data-recaptcha]').val(response).trigger('change')
        }

        window.expiredRecaptchaCallback = function () {
            $('input[data-recaptcha]').val("").trigger('change')
        }

        $('#user_login').on('submit', function (e) {
            e.preventDefault();
            $('.messages').empty();
            $('.login-loader').addClass('show');

            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php?action=nystpba_login',
                data: $(this).serialize(),
                success: function (data) {
                    var response = JSON.parse(data);

                    var stringBuilder = '';
                    if (response.success == true) {
                        stringBuilder = stringBuilder + '<div class="alert alert-success" role="alert">';
                        stringBuilder = stringBuilder + 'Success! Please wait.'
                        stringBuilder = stringBuilder + '</div>';
                        window.location.replace('/members');
                    } else {
                        stringBuilder = stringBuilder + '<div class="alert alert-danger" role="alert">';
                        stringBuilder = stringBuilder + response.message
                        stringBuilder = stringBuilder + '</div>';
                        grecaptcha.reset();
                    }

                    $('.messages').append(stringBuilder);
                    $('.login-loader').removeClass('show');
                }
            });
        });
    });

    $('#user_login').on('input', function () {
        $('.messages').empty();
    });

})(jQuery);